'use client';
import { formatTitle } from '@components/events/league-heading';
import { addQueryParam } from '@utils/add-query-param';
import { getLeagueLandingPath } from '@utils/navigation/league-public-paths';
import { ChevronLeft } from '@v2/ui/Icon/Arrow';
import { CONCERTS_SLUGS } from 'app/(v2)/events/[league]/[[...team]]/data';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { CONCERTS_ID } from '../util';

type Props = {
  leagueSlug: string;
  teamSlug?: string;
  breadcrumbLabel?: string;
};

export default function EventHeroSectionGoBack({
  leagueSlug,
  teamSlug,
  breadcrumbLabel,
}: Props) {
  const searchParams = useSearchParams();
  const partnerSlug = searchParams?.get('partnerSlug');

  const isTeamPage = !!teamSlug;

  const isConcerts = CONCERTS_SLUGS.includes(leagueSlug);
  const isEuropeanSoccerLeague = [
    'premier-league',
    'la-liga',
    'serie-a',
    'bundesliga',
    'ligue-1',
  ].includes(leagueSlug.toLowerCase());

  const defaultBreadcrumbLabel = formatTitle[leagueSlug.toLowerCase()]
    ? isEuropeanSoccerLeague
      ? formatTitle[leagueSlug.toLowerCase()]
      : formatTitle[leagueSlug.toLowerCase()].replace('Travel Packages', '')
    : CONCERTS_SLUGS.includes(leagueSlug)
      ? 'Concerts'
      : 'Travel Packages';

  return (
    <>
      {isTeamPage && (
        <Link
          prefetch={false}
          href={
            isConcerts
              ? `${getLeagueLandingPath(leagueSlug)}?${addQueryParam({ parentId: CONCERTS_ID[0], partnerSlug: partnerSlug })}`
              : `${getLeagueLandingPath(leagueSlug)}?${addQueryParam({ partnerSlug: partnerSlug })}`
          }
          className="flex items-center gap-x-2 text-gray-400"
        >
          <ChevronLeft size="20" />
          {breadcrumbLabel ?? defaultBreadcrumbLabel}
        </Link>
      )}
    </>
  );
}
